import { AxiosError, AxiosResponse } from "axios";
import { DataType, FieldType } from "@websential/cosmic-v20";
import {
	IEarnings,
	IEarningsListPayload,
	IEarningsResponse,
} from "../models/Earnings";
import { IGetListRequest, IResponse, IServerError } from "../models/common";

import { GridSize } from "@mui/material";
import { IPayrollFederalEarnings } from "../models/PayrollFederalEarningsSetup";
import http from "../common/http-commons";

// import { IFixedAndMetaField } from 'common/FlexFieldsUtils';

// import { IVendorListPayload, IVendorRequest, IVendorResponse } from 'models/vendor';
// import { CLIENT_SETUP_FORM, CLIENT_SETUP_FORM_FOR_ADMIN_USER } from 'screensLayoutData/client';

// import { IAPIKeysRequest, IAPIKeysResponse } from '../models';

// import { IEarningsListPayload, IEarningsRequest, IEarningsResponse } from '../models/earnings';

// import { INITIAL_PAGE_SIZE } from 'common/constants';

export const PayrollFederalEarningService = {
	getEarnings: async (
		clientId: string,
		data: IGetListRequest,
		navigateToLogout: (path: string) => void
	): Promise<
		IEarningsListPayload | IServerError | IResponse | IEarningsResponse[]
	> => {
		try {
			const response: AxiosResponse<IEarningsListPayload> =
				await http.get<IEarningsListPayload>(
					"/v1/payroll-federal-taxable-earning/" +
						"?order_by=" +
						data.order_by +
						"&order_direction=" +
						data.order_direction +
						"&page=" +
						data.page +
						"&size=" +
						data.size +
						"&search_query=" +
						data.search_query
				);

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}
			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
		// const fixedResponse: any = {
		// 	page: 0,
		// 	size: 0,
		// 	total: 0,
		// 	items: [
		// 		{
		// 			id: "6868cd99f63629ca30402977",
		// 			earningId: "6868cd99f63629ca30402939",
		// 			earningLabel: "Bonus",
		// 			enable: true,
		// 			alberta: {
		// 				label: "Alberta",
		// 				status: 100,
		// 			},
		// 			britishColumbia: {
		// 				label: "British Columbia",
		// 				status: 200,
		// 			},
		// 			manitoba: {
		// 				label: "Manitoba",
		// 				status: 200,
		// 			},
		// 			newBrunswick: {
		// 				label: "New Brunswick",
		// 				status: 100,
		// 			},
		// 			newfoundlandAndLabrador: {
		// 				label: "Newfoundland and Labrador",
		// 				status: 100,
		// 			},
		// 			northwestTerritories: {
		// 				label: "Northwest Territories",
		// 				status: 300,
		// 			},
		// 			novaScotia: {
		// 				label: "Nova Scotia",
		// 				status: 300,
		// 			},
		// 			nunavut: {
		// 				label: "Nunavuterta",
		// 				status: 300,
		// 			},
		// 			ontario: {
		// 				label: "Ontario",
		// 				status: 100,
		// 			},
		// 			princeEdwardIsland: {
		// 				label: "Prince Edward Island",
		// 				status: 100,
		// 			},
		// 			quebec: {
		// 				label: "Quebec",
		// 				status: 200,
		// 			},
		// 			saskatchewan: {
		// 				label: "Saskatchewan",
		// 				status: 200,
		// 			},
		// 			yukon: {
		// 				label: "Yukon",
		// 				status: 100,
		// 			},
		// 			province: [
		// 				{
		// 					label: "Alberta",
		// 					status: 100,
		// 				},
		// 				{
		// 					label: "British Columbia",
		// 					status: 200,
		// 				},
		// 				{
		// 					label: "Manitoba",
		// 					status: 200,
		// 				},
		// 				{
		// 					label: "New Brunswick",
		// 					status: 100,
		// 				},
		// 				{
		// 					label: "Newfoundland and Labrador",
		// 					status: 100,
		// 				},
		// 				{
		// 					label: "Northwest Territories",
		// 					status: 300,
		// 				},
		// 				{
		// 					label: "Nova Scotia",
		// 					status: 300,
		// 				},
		// 				{
		// 					label: "Nunavuterta",
		// 					status: 300,
		// 				},
		// 				{
		// 					label: "Ontario",
		// 					status: 100,
		// 				},
		// 				{
		// 					label: "Prince Edward Island",
		// 					status: 100,
		// 				},
		// 				{
		// 					label: "Quebec",
		// 					status: 200,
		// 				},
		// 				{
		// 					label: "Saskatchewan",
		// 					status: 200,
		// 				},
		// 				{
		// 					label: "Yukon",
		// 					status: 100,
		// 				},
		// 			],
		// 			effectiveDate: "2025-07-04",
		// 			endDate: null,
		// 		},
		// 	],
		// 	headerColumns: [
		// 		{
		// 			field: "earningLabel",
		// 			headerName: "Earning Type",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			sequence: 0,
		// 			frozenColumn: false,
		// 			footer: 0,
		// 			minWidth: 500,
		// 			maxWidth: 500,
		// 		},
		// 		{
		// 			field: "alberta.status",
		// 			fieldName: "alberta",
		// 			headerName: "AB",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: false,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "center",
		// 			headerAlign: "center",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			sequence: 0,
		// 			frozenColumn: false,
		// 			footer: 0,
		// 			minWidth: null,
		// 			maxWidth: null,
		// 		},
		// 		{
		// 			field: "britishColumbia.status",
		// 			fieldName: "britishColumbia",
		// 			headerName: "BC",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: false,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "center",
		// 			headerAlign: "center",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			sequence: 0,
		// 			frozenColumn: false,
		// 			footer: 0,
		// 			minWidth: null,
		// 			maxWidth: null,
		// 		},
		// 		{
		// 			field: "manitoba.status",
		// 			fieldName: "manitoba",
		// 			headerName: "MB",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: false,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "center",
		// 			headerAlign: "center",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			sequence: 0,
		// 			frozenColumn: false,
		// 			footer: 0,
		// 			minWidth: null,
		// 			maxWidth: null,
		// 		},
		// 		{
		// 			field: "newBrunswick.status",
		// 			fieldName: "newBrunswick",
		// 			headerName: "NB",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: false,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "center",
		// 			headerAlign: "center",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			sequence: 0,
		// 			frozenColumn: false,
		// 			footer: 0,
		// 			minWidth: null,
		// 			maxWidth: null,
		// 		},
		// 		{
		// 			field: "newfoundlandAndLabrador.status",
		// 			fieldName: "newfoundlandAndLabrador",
		// 			headerName: "NL",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: false,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "center",
		// 			headerAlign: "center",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			sequence: 0,
		// 			frozenColumn: false,
		// 			footer: 0,
		// 			minWidth: null,
		// 			maxWidth: null,
		// 		},
		// 		{
		// 			field: "novaScotia.status",
		// 			fieldName: "novaScotia",
		// 			headerName: "NS",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: false,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "center",
		// 			headerAlign: "center",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			sequence: 0,
		// 			frozenColumn: false,
		// 			footer: 0,
		// 			minWidth: null,
		// 			maxWidth: null,
		// 		},
		// 		{
		// 			field: "northwestTerritories.status",
		// 			fieldName: "northwestTerritories",
		// 			headerName: "NT",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: false,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "center",
		// 			headerAlign: "center",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			sequence: 0,
		// 			frozenColumn: false,
		// 			footer: 0,
		// 			minWidth: null,
		// 			maxWidth: null,
		// 		},
		// 		{
		// 			field: "nunavut.status",
		// 			fieldName: "nunavut",
		// 			headerName: "NU",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: false,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "center",
		// 			headerAlign: "center",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			sequence: 0,
		// 			frozenColumn: false,
		// 			footer: 0,
		// 			minWidth: null,
		// 			maxWidth: null,
		// 		},
		// 		{
		// 			field: "ontario.status",
		// 			fieldName: "ontario",
		// 			headerName: "ON",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: false,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "center",
		// 			headerAlign: "center",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			sequence: 0,
		// 			frozenColumn: false,
		// 			footer: 0,
		// 			minWidth: null,
		// 			maxWidth: null,
		// 		},
		// 		{
		// 			field: "princeEdwardIsland.status",
		// 			fieldName: "princeEdwardIsland",
		// 			headerName: "PE",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: false,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "center",
		// 			headerAlign: "center",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			sequence: 0,
		// 			frozenColumn: false,
		// 			footer: 0,
		// 			minWidth: null,
		// 			maxWidth: null,
		// 		},
		// 		{
		// 			field: "quebec.status",
		// 			fieldName: "quebec",
		// 			headerName: "QC",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: false,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "center",
		// 			headerAlign: "center",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			sequence: 0,
		// 			frozenColumn: false,
		// 			footer: 0,
		// 			minWidth: null,
		// 			maxWidth: null,
		// 		},
		// 		{
		// 			field: "saskatchewan.status",
		// 			fieldName: "saskatchewan",
		// 			headerName: "SK",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: false,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "center",
		// 			headerAlign: "center",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			sequence: 0,
		// 			frozenColumn: false,
		// 			footer: 0,
		// 			minWidth: null,
		// 			maxWidth: null,
		// 		},
		// 		{
		// 			field: "yukon.status",
		// 			fieldName: "yukon",
		// 			headerName: "YT",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: false,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "center",
		// 			headerAlign: "center",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			sequence: 0,
		// 			frozenColumn: false,
		// 			footer: 0,
		// 			minWidth: null,
		// 			maxWidth: null,
		// 		},
		// 		{
		// 			field: "effectiveDate",
		// 			headerName: "Effective Date",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			sequence: 0,
		// 			frozenColumn: false,
		// 			footer: 0,
		// 			minWidth: null,
		// 			maxWidth: null,
		// 		},
		// 	],
		// };
		// return new Promise((resolve) =>
		// 	setTimeout(() => resolve(fixedResponse), 1000)
		// );
	},
	getById: async (
		id: string | undefined,
		navigateToLogout: (path: string) => void
	): Promise<IEarnings | IServerError | IResponse | null | any> => {
		if (!id) return null;
		try {
			const response: AxiosResponse<IEarnings> = await http.get<IEarnings>(
				`/v1/payroll-federal-taxable-earning/${id}/`
			);

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	create: async (
		requestPayload: any
	): Promise<IPayrollFederalEarnings | IServerError | IResponse | any> => {
		if (requestPayload.id) {
			
			try {
				const response: AxiosResponse<IEarnings> = await http.put<IEarnings>(
					`/v1/payroll-federal-taxable-earning/${requestPayload.id}/`,
					requestPayload
				);

				if (response.status === 200) {
					return response;
				} else if (response.status === 400) {
					return response.data;
				} else if (response.status === 500) {
					return {
						status: false,
						message: "Something went wrong.",
						error: true,
					};
				}
			} catch (error) {
				const axiosError = error as AxiosError;
				console.error("An error occurred:", axiosError);
				const errorMessage =
					axiosError.response && typeof axiosError.response.data === "string"
						? axiosError.response.data
						: "Unknown error";
				if (axiosError && axiosError.status === 401) {
					requestPayload.navigateToLogout("/logout");
					return {
						status: false,
						message: "UnAuthrized",
					};
				} else {
					return {
						status: false,
						message: errorMessage,
					};
				}
			}
		}

		
		try {
			const response: AxiosResponse<IPayrollFederalEarnings> =
				await http.post<IPayrollFederalEarnings>(
					`/v1/payroll-federal-taxable-earning/`,
					requestPayload
				);

		
			if (response.status === 201) {
				return response;
			} else if (response.status === 400) {
				return response.data;
			} else if (response.status === 401) {
				// window.location.href = '/logout';
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				requestPayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	delEarnings: async (
		delPayload: any
	): Promise<string | IServerError | IResponse | any> => {
		
		// return new Promise(resolve => setTimeout(() => resolve("Flex Field has been deleted successfully"), 1000));
		try {
			const response: AxiosResponse<string> = await http.delete<string>(
				`/v1/payroll-federal-taxable-earning/`
			);

			if (response.status === 204) {
				return "payroll federal taxable has been deleted successfully";
			} if (response.status === 200) {
				return "payroll federal taxable has been deleted successfully";
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				delPayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	delBulkEarningses: async (
		requestPayload: any
	): Promise<string | IServerError | IResponse> => {
	
		try {
			const response = await http.delete<string>(
				`/v1/payroll-federal-taxable-earning/`,
				{
					data: requestPayload.earningsIds,
				}
			);
			if (response.status === 200) {
				return response.data;
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}
		
			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				requestPayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	archiveEarnings: async (
		archivePayload: any
	): Promise<string | IServerError | IResponse | any> => {
		
		// return new Promise(resolve => setTimeout(() => resolve("Flex Field has been deleted successfully"), 1000));
		try {
			const response: AxiosResponse<string> = await http.post<string>(
				`/v1/payroll-federal-taxable-earning/${archivePayload.earningsId}/`
			);

			if (response.status === 201) {
				return "Earnings has been archived successfully";
			} else if (response.status === 200) {
				return "Earnings has been archived successfully";
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				archivePayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
};
